import { computed, ref } from 'vue'
export const canAccessWorkspace = ref(false)
export const isSharePage = new URLSearchParams(location.search).has('share')
export const canNavigateHome = computed(()=>canAccessWorkspace.value && !isSharePage)
export const isHomePage = ref(true)
let returnHome = () => {}
export function connectHome(handler:()=>void){returnHome=handler}
export function navigateHome(){if(canNavigateHome.value)returnHome()}
